import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {formValidator} from 'commons/utils/Functions';
import InnerFormProfileInfo from './InnerFormProfileInfo';
import {TransactionalProfileServiceRequest} from 'commons/models';

ProfileInfoForm.propTypes = {
    title: PropTypes.string.isRequired,
    submitHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
    profile: PropTypes.any
};

const FormControl = withFormik<
    InferPropTypes<typeof ProfileInfoForm.propTypes>,
    TransactionalProfileServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            transactionsNumberPerMonth: '',
            transactionsAmountPerMonth: '',
            averageIncomePerYear: '',
            mainIncomeSource: '',
            otherIncomeSource: '',
            resourceDestination: ''
        };
    },
    mapPropsToValues: (props) => {
        const {profile} = props;
        if (profile) {
            return {
                expedientId: profile.expedientId,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                transactionsNumberPerMonth: profile.transactionsNumberPerMonth || '',
                transactionsAmountPerMonth: profile.transactionsAmountPerMonth || '',
                averageIncomePerYear: profile.averageIncomePerYear || '',
                mainIncomeSource: profile.mainIncomeSource || '',
                otherIncomeSource: profile.otherIncomeSource || '',
                resourceDestination: profile.resourceDestination || '',
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                transactionsNumberPerMonth: '',
                transactionsAmountPerMonth: '',
                averageIncomePerYear: '',
                mainIncomeSource: '',
                otherIncomeSource: '',
                resourceDestination: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: TransactionalProfileServiceRequest, props) => {
        const errors: FormikErrors<TransactionalProfileServiceRequest> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormProfileInfo);

function ProfileInfoForm(
    props: InferPropTypes<typeof ProfileInfoForm.propTypes>
) {
    const {submitHandler, isLoading, fields, title, profile} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            title={title}
            fields={fields}
            submitHandler={submitHandler}
            isLoading={isLoading}
            profile={profile}
        />
    );
}

export default ProfileInfoForm;
